
<script>

</script>
<template>
    <div class="goods">
      <Scroll :height="scrollHeight">

        <van-nav-bar title="固资信息查询" left-text="返回" right-text="重置" left-arrow @click-left="getRouteQuery()" @click-right="handleReset" />

        <van-form @submit="handleSubmit" ref="asset" style="overflow-y: auto;" >

        <van-divider />
            <van-field v-model="formValidate.name" name="姓名" label="姓名" placeholder="请输入姓名" :readonly="readonly" :rules="[{ required: true, message: '请填姓名' }]" size="large" @blur="checkUser"></van-field>

            <van-field readonly clickable name="邮箱" :value="formValidate.mail" label="邮箱" placeholder="点击选择邮箱" :rules="[{ required: true, message: '请选择邮箱' }]" @click="readonly?'':showUserPicker = true" size="large"/>

            <van-field v-model="formValidate.department" name="部门" label="部门" placeholder="检索部门" readonly size="large" type="textarea" rows="1"/>

            <van-field v-model="formValidate.created_at" name="时间" label="时间" placeholder="时间" readonly size="large"/>

            <van-field v-show="readonly" v-model="formValidate.sn_list[index]" center label="资产编码" placeholder="请输入资产编码" v-for="(_, index) in formValidate.sn_list" :key="index" :readonly="formValidate.sn_list_disable[index]" size="large">
              <template #button>
                <van-icon v-show="!formValidate.sn_list_disable[index]" @click="setDisable" name="checked" size="large" />
                <van-icon  @click="remove(index)" style="margin-left: 10px;" name="clear" size="large"/>
              </template>
            </van-field>

            <van-checkbox-group v-show="formValidate.sn_list.length !== 0 && formValidate.sn_list[0] && !readonly" v-model="sn_list_result">
              <van-divider dashed :margin="12">已有资产编码</van-divider>
              <van-cell-group>
                <van-cell
                  v-for="(item, index) in formValidate.sn_list"
                  clickable
                  :key="item"
                  :title="`${item}【${sn_asset_type_name_dict[item]}】`"
                  @click="toggle(index)"
                >
                  <template #right-icon>
                    <van-checkbox :name="item" ref="checkboxes" />
                  </template>
                </van-cell>
              </van-cell-group>
            </van-checkbox-group>

            <van-divider v-show="formValidate.new_sn_list.length !== 0" dashed :margin="12">新资产编码</van-divider>
            <van-field v-show="formValidate.new_sn_list.length !== 0" v-model="formValidate.new_sn_list[index]" center label="资产编码" placeholder="请输入资产编码" v-for="(_, index) in formValidate.new_sn_list" :key="index" :readonly="formValidate.new_sn_list_disable[index]" size="large">
              <template #button>
                <van-icon v-if="!formValidate.new_sn_list_disable[index]" @click="setDisable" name="checked" size="large" />
                <van-icon  @click="remove(index)" style="margin-left: 10px;" name="clear" size="large"/>
              </template>
            </van-field>
            <van-button v-show="!readonly" icon="plus" round block type="default" @click="add()" size="small" color="#7232dd" plain></van-button>

            <van-field v-model="formValidate.remark" name="备注" label="备注" placeholder="请输入备注" :readonly="readonly" size="large"></van-field>

            <div style="margin: 16px;">
              <van-button round block type="info" native-type="submit" size="large" color="#7232dd">资产确认</van-button>
            </div>
        </van-form>

        <div id="app">
          <van-popup v-model="showUserPicker" get-container="#app" position="bottom" :lock-scroll="false">
            <van-picker
              show-toolbar
              :columns="emailList"
              @confirm="onEmailConfirm"
              @cancel="showUserPicker = false"
            />
            </van-popup>
        </div>

      </Scroll>

    </div>
</template>
<script>
import { Button, Form, Field, NavBar, Popup, Picker, Checkbox, Icon, Toast, Divider, Notify, Steps, Step, Tag, List, Cell, CheckboxGroup, Tab, Tabs, Dialog} from 'vant'
import { authByName } from '@/api/user'
import { getAssetDataByWorkflow, getAssetDataByName, addAssetInventoryInformation, getAssetInventoryInformation } from '@/api/cmdb'
import moment from 'moment'
import { getToken } from '@/libs/util'
import 'vant/lib/index.css';
export default {
  components: { [Button.name]: Button,  [Form.name]: Form,  [Field.name]: Field, [NavBar.name]: NavBar, [Popup.name]: Popup,  [Picker.name]: Picker,  [Checkbox.name]: Checkbox,  [Icon.name]: Icon, [Divider.name]: Divider,
                  [Steps.name]: Steps, [Step.name]: Step, [Tag.name]: Tag , [List.name]: List, [Cell.name]: Cell, [CheckboxGroup.name]: CheckboxGroup, [Tab.name]: Tab, [Tabs.name]: Tabs, [Dialog.Component.name]: Dialog.Component },
  data () {
    return {
      formValidate: {
        name: null,
        mail: null,
        userid: null,
        department: null,
        created_at: '',
        sn_list: [''],
        sn_list_disable: [false],
        new_sn_list: [],
        new_sn_list_disable: [],
        remark: null,
        sn_type: null
      },
      readonly: false,
      showUserPicker: false,
      emailList: [],
      emailDict: {},
      active: 1,
      scrollHeight: 0,
      sn_list_result: [],
      sn_asset_type_name_dict: {},
      sn_asset_dict: {},
    }
  },

  mounted () {
    if (!getToken() && this.$route.query.token !== 'searchAuGroup') {
      this.$router.push({
        path: '/401'
      })
    }
    setTimeout(()=>{
      this.getRouteQuery()
    }, 500)
    this.scrollHeight = window.innerHeight
  },
  methods: {
    toggle(index) {
      this.$refs.checkboxes[index].toggle()
    },
    getRouteQuery(reset){
      const {  id, readonly, sn } = this.$route.query
      if (id){
        this.formValidate.id = id
      }
      if(id && !reset){
        getAssetInventoryInformation({id: id}).then(rsp=>{
          const { data } = rsp.data
          if (!data.id){
            return
          }
          this.formValidate.id = data.id
          Object.keys(this.formValidate).forEach(key=>{
            if (data[key]){
              this.formValidate[key] = data[key]
            }
            this.formValidate.sn_list_disable = []
            this.formValidate.sn_list.forEach(_s=>{
              this.formValidate.sn_list_disable.push(true)
            })
          })
          if(data.approval){
            this.formValidate.approval = data.approval
            this.active = 1
          }
          if (data.sn_list.length === 0){
            this.getSnList()
          }
          this.readonly = true
        })
      }
    },

    getSnList(){
      getAssetDataByName({name: this.formValidate.name}).then(rsp=>{
          const { data } = rsp.data
          this.formValidate.sn_list = []
          this.formValidate.sn_list_disable = []
          data.forEach(_sn=>{
            if(_sn.asset_info){
              this.sn_asset_type_name_dict[_sn.asset_id] = _sn.asset_type_name
              this.sn_asset_dict[_sn.asset_id] = _sn
            }
            this.formValidate.sn_list.push(_sn.asset_id)
            this.formValidate.sn_list_disable.push(false)
          })
        })
    },

    handleReset () {
      this.formValidate = {
        name: null,
        mail: null,
        userid: null,
        department: null,
        created_at: null,
        sn_list: [''],
        sn_list_disable: [false],
        new_sn_list: [],
        new_sn_list_disable: [],
        remark: null,
      }
      this.readonly = false
    },

    onEmailConfirm (value) {
      this.formValidate.mail = value
      if(this.emailDict[value]){
        this.formValidate.name = this.emailDict[value].name
        this.formValidate.mail = value
        this.formValidate.userid = this.emailDict[value].userid
        this.formValidate.department = this.emailDict[value].unitFullName
        this.getSnList()
      }
      this.showUserPicker = false
    },

    remove (index) {
      console.log(index, !this.readonly)
      if(!this.readonly){
        this.formValidate.new_sn_list.splice(index, 1)
        this.formValidate.new_sn_list_disable.splice(index, 1)
      }
    },

    setDisable () {
      for(let i=0; i < this.formValidate.new_sn_list.length; i++){
        getAssetDataByWorkflow({asset_id : this.formValidate.new_sn_list[i]}).then(rsp=>{
            const {data, code, msg} = rsp.data
            if(code === 500){
              Notify({ type: 'danger', message: msg, duration: 5000 })
            }else if (data.asset_id){
              this.sn_asset_dict[data.asset_id] = data
              this.formValidate.new_sn_list_disable[i] = true
              const new_sn_list = this.formValidate.new_sn_list
              this.formValidate.new_sn_list = []
              new_sn_list.forEach(sn => {
                this.formValidate.new_sn_list.push(sn)
              })
            }else{
              Notify({ type: 'danger', message: `无资产编码【${this.formValidate.sn_list[i]}】的资产信息, 请检查, 重新输入` })
            }
          })
      }
    },

    add () {
      this.formValidate.new_sn_list.push('')
      this.formValidate.new_sn_list_disable.push(false)
    },

    checkUser(){
        this.emailList = []
        if (!this.formValidate.name){
          Toast.loading({ message: '输入姓名不能为空', forbidClick: true})
          return
        }else{
          Toast.loading({ message: '正在检索用户信息...', forbidClick: true, duration: 120000})
        }
        authByName( {name : this.formValidate.name} ).then(rsp=>{
            Toast.clear()
            if(Object.keys(rsp.data).length === 0){
                Toast.fail("未找到用户信息, 请重新输入")
            }else{
                const { data } = rsp.data
                data.forEach(_user=>{
                  this.emailList.push(_user.email)
                  this.emailDict[_user.email] = _user
                })
                this.formValidate.mail = null
                this.formValidate.userid = null
                this.formValidate.department = null
                this.formValidate.created_at = moment(new Date()).format('YYYY-MM-DD HH:mm:ss')
                this.showUserPicker = true
                if(Object.keys(rsp.data).length === 1){
                  this.formValidate.name = data[0].name
                  this.formValidate.mail = data[0].email
                  this.formValidate.userid = data[0].userid
                  this.formValidate.department = data[0].unitFullName
                  this.getSnList()
                  this.showUserPicker = false
                }
            }
        }).catch(_=>{
            Toast.clear()
        })
    },

    addAssetInventoryInformation(param){
      addAssetInventoryInformation(param).then(rsp=>{
        Toast.clear()
        const {code, msg} = rsp
        if (code === 200){
          Toast.success({ message: msg, forbidClick: true })
        }
      }).catch(err=>{
        Notify({ type: 'danger', message: err })
      })
    },

    handleSubmit () {

      // 全局表单验证
      this.$refs.asset.validate().then(() => {
        this.setDisable()
        setTimeout(()=>{
          if(this.sn_list_result.length === 0 && this.formValidate.new_sn_list.length === 0){
            Notify({ type: 'danger', message: `资产信息不能为空` })
            return
          }

          if(this.formValidate.new_sn_list.length !== 0){
            if(this.formValidate.new_sn_list_disable.indexOf(false) !== -1){
              console.log(this.formValidate.sn_list_disable)
              Notify({ type: 'danger', message: `请检查资产编号是否填写正确` })
              return
            }
          }

          Toast.loading({ message: '提交中...', forbidClick: true, duration: 10000 })

          const formValidate =  {...this.formValidate}

          Object.keys(this.sn_asset_dict).forEach(_s=>{
            const param = {
              name: formValidate.name,
              userid: formValidate.userid,
              mail: formValidate.mail,
              department: formValidate.department,
              sn: _s,
              sn_info: this.sn_asset_dict[_s],
              created_at:  moment(new Date()).format('YYYY-MM-DD HH:mm:ss'),
              inventory_date: moment(new Date()).format('YYYY年MM月'),
              operate_remark: '',
              remark:  formValidate.remark,
              original_assets: formValidate.sn_list,
              sn_type: this.sn_asset_type_name_dict[_s]
            }
            if(this.sn_list_result.indexOf(_s) !== -1){
              param.status = '正常'
            }else{
              param.status = '异常'
            }
            this.addAssetInventoryInformation(param)
          })

          this.formValidate.new_sn_list.forEach(_s=>{
            const param = {
              name: formValidate.name,
              userid: formValidate.userid,
              mail: formValidate.mail,
              department: formValidate.department,
              sn: _s,
              sn_info: this.sn_asset_dict[_s],
              created_at:  moment(new Date()).format('YYYY-MM-DD HH:mm:ss'),
              inventory_date: moment(new Date()).format('YYYY年MM月'),
              operate_remark: '',
              remark:  formValidate.remark,
              original_assets: formValidate.sn_list,
              status: '新增',
              sn_type: this.sn_asset_type_name_dict[_s]
            }
            this.addAssetInventoryInformation(param)
          })
          setTimeout(()=>{
            Notify({ type: 'success', message: `提交成功`, duration: 10000 })
            this.$router.push({path: '/front/cmdb/workflow/search-list', query: {token: 'searchAuGroup', searchKey: this.formValidate.mail}})
            this.readonly = true
            this.handleReset()
            }, 800)
        }, 800)

      })
    },
  },

}

</script>

<style scoped>
::v-deep.van-field__control::-webkit-input-placeholder {
    font-size: 100px;
}
</style>

</script>
<style lang="less">
.goods {
  padding-bottom: 50px;

  &-swipe {
    img {
      width: 100%;
      display: block;
    }
  }

  &-title {
    font-size: 16px;
  }

  &-price {
    color: #f44;
  }

  &-express {
    color: #999;
    font-size: 12px;
    padding: 5px 15px;
  }

  &-cell-group {
    margin: 15px 0;

    .van-cell__value {
      color: #999;
    }
  }

  &-tag {
    margin-left: 5px;
  }
}
</style>
